import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=fc89715a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc89715a')) {
      api.createRecord('fc89715a', component.options)
    } else {
      api.reload('fc89715a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=fc89715a&", function () {
      api.rerender('fc89715a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dfpK4DzfU6f6/JS/pricehelp.vue"
export default component.exports